export const openingsHours = [
	{
		day: "Monday",
		time: { from: 16, to: 22 },
	},
	{
		day: "Tuesday",
		time: { from: 14, to: 22 },
	},
	{
		day: "Wednesday",
		time: { from: 14, to: 22 },
	},
	{
		day: "Thursday",
		time: { from: 14, to: 22 },
	},
	{
		day: "Friday",
		time: { from: 14, to: 22 },
	},
	{
		day: "Saturday",
		time: { from: 14, to: 22 },
	},
	{
		day: "Sunday",
		time: { from: 16, to: 22 },
	},
];
